import styled from 'styled-components';
import { ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import Tag from 'components/generic/tag';

const TagContainer = styled.div`
    position: absolute;
    top: ${({ theme }) => theme.Spacing8};
    left: ${({ theme }) => theme.Spacing8};
    right: ${({ theme }) => theme.Spacing8};
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.Spacing4};
`;

const StyledTag = styled(Tag)`
    background-color: ${ColorNeutralWhite};
`;

function TagList({ tags }: { tags?: string[] }) {
    if (!tags?.length) return null;
    return (
        <TagContainer>
            {tags.map((tag, index) => (
                <StyledTag key={index}>{tag}</StyledTag>
            ))}
        </TagContainer>
    );
}

export default TagList;
